<template>
  <div id="my_box" :class="['relativeItem', { idx_padd: showMeBox }]">
    <div class="back_box" @click="goBack">
      <img
        class="imgBlock noevents-img"
        src="../../assets/flower/backicon.png"
      />
    </div>

    <div class="top_con relativeItem">
      <img
        class="imgBlock noevents-img"
        src="../../assets/flower/meimg003.png"
      />
      <div id="anibg" class="ani_bg"></div>

      <!-- 玫瑰的图 -->
      <div class="absoluteItem flwr_mg" v-if="type == 1">
        <img
          class="imgBlock noevents-img"
          src="../../assets/flower/imgmg.png"
        />
      </div>
      <!-- 向日葵 -->
      <div class="absoluteItem flwr_xr" v-else>
        <img
          class="imgBlock noevents-img"
          src="../../assets/flower/imgxrk.png"
        />
      </div>

      <div class="me_hua absoluteItem centerX" v-if="isMe">我的花卉</div>
      <div class="me_hua absoluteItem centerX" v-else>TA的花卉</div>

      <div class="total_box absoluteItem">
        <div class="sun_allcon">
          <img
            class="imgBlock noevents-img sunimg"
            src="../../assets/flower/sun01.png"
          />
        </div>
        <div class="sun_num">
          <p>阳光总值</p>
          <p>{{ anchorTotal }}</p>
        </div>
      </div>

      <!-- 洒阳光的 -->
      <div
        class="sasun_box absoluteItem sa_ani"
        v-if="(isMe && isBind == 1) || meBdid == 0"
      >
        <!-- 我的并且绑了的显示  榜单点击未绑就显示   绑了判断是不是和自己帮的一样就显示 不一样不显示       -->
        <div class="baisun_con relativeItem">
          <img
            class="imgBlock noevents-img bai_sbg"
            src="../../assets/flower/baisbg.png"
          />
          <img
            class="imgBlock noevents-img bai_sun absoluteItem"
            src="../../assets/flower/baisun.png"
          />
          <div class="absoluteItem can_sun">
            <img
              class="imgBlock noevents-img"
              src="../../assets/flower/sunnumimg.png"
            />
            <p class="absoluteItem centerX" v-if="canUseNum > 99">99+</p>
            <p class="absoluteItem centerX" v-else>{{ canUseNum }}</p>
          </div>
        </div>
        <div
          class="sa_btns relativeItem"
          @click="saBtnStart"
          v-if="canSaSun && canUseNum != 0"
        >
          <img
            class="imgBlock noevents-img"
            src="../../assets/flower/sabtn.png"
          />
        </div>
        <div class="sa_btns relativeItem" v-else>
          <img
            class="imgBlock noevents-img"
            src="../../assets/flower/sabtnhui.png"
          />
        </div>
      </div>
    </div>

    <div class="main_con">
      <div class="btn_top relativeItem mar_top">
        <img
          class="imgBlock noevents-img bgimg_btn"
          src="../../assets/flower/bg00.png"
        />
        <div class="centerImg absoluteItem">阳光贡献榜</div>
      </div>
      <div class="mar_top">
        <listCom
          :titText="titText"
          :rankList="rankList"
          :showSearchBox="SearchBoxShow"
          :isAnchor="isAnchor"
          :btnIdx="456"
          :showStext="showStext"
          :showNo="showNo"
        ></listCom>
      </div>

      <p class="sp_p">本活动最终解释权归朱贝平台所有</p>

      <!-- 我的花卉显示我的排行 -->
      <div v-if="showMeBox" class="me_fixed">
        <div class="relativeItem me_main">
          <img
            class="imgBlock noevents-img"
            src="../../assets/flower/minebg.png"
          />
          <div class="absoluteItem me_box flex-box">
            <div class="me_pai">
              <p class="wei_pai" v-if="meRank == 0">未上榜</p>
              <p class="wei_pai" v-if="meRank != 0">{{ meRank }}</p>
            </div>
            <div class="me_avat">
              <img
                class="imgBlock noevents-img"
                :src="meAvat"
                onerror="this.src = 'http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
              />
            </div>
            <div class="me_info">
              <p class="apostrophe">{{ meName }}</p>
              <p>贡献阳光值：{{ meSunNum }}</p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <img
          class="imgBlock noevents-img"
          src="../../assets/flower/botye.png"
        />
      </div>
    </div>
  </div>
</template>











<script>
import listCom from "./rankListCom";
import lottie from "lottie-web";

export default {
  name: "myFlower",
  components: {
    listCom,
  },
  data() {
    return {
      isAnchor: 0, //都是用户
      type: 1, // type 1 玫瑰     2向日葵
      isMe: true, //是我的花卉  还是他的
      titText: "贡献",
      SearchBoxShow: false,
      anchorId: 0, //绑定主播的id
      isBind: 0, // 和当前花的绑定状态 0未绑    1 绑定
      anchorAllSunny: 0, //主播的阳光总量  用于计算的
      anchorTotal: "0", //处理过阳光总量数值过万后的
      canUseNum: 0, //可使用的阳光总量   大于99及时 99+
      meRank: "0", //自己的名次
      meName: "",
      meAvat: "",
      meSunCalu: 0, // 自己的贡献阳光值 用于计算的
      meSunNum: 0, // 自己的贡献阳光值 用于显示的处理大于六位数的
      rankList: [],
      aniObj1: null, //动画一的
      canSaSun: true,
      showNo: false, //空视图的显示
      showStext: true,
      showMeBox: false, //主播不显示我的信息   用户仅在自己的花卉页面才显示
      meBdid: 0, //自己绑定的花id
    };
  },
  mounted() {
    this.$tool.setTitle("花卉");
    this.judgeLinkParam();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    //获取链接的 参数
    judgeLinkParam() {
      if (this.$route.query.bindid) {
        this.anchorId = this.$route.query.bindid;
        this.getAnchorFlower();
      }
      if (this.$route.query.isme) {
        this.isMe = true;
      } else {
        this.isMe = false;
      }

      if (this.$route.query.ident == 0 && this.isMe) {
        // 用户展示底部我的信息  主播不展示
        this.showMeBox = true;
      } else {
        this.showMeBox = false;
      }
      if (this.$route.query.meBid == 0) {
        this.meBdid = 0;
      } else {
        this.meBdid = this.$route.query.meBid;
      }
    },

    //获取绑定主播的花卉类型
    getAnchorFlower() {
      let _this = this;
      let data = {
        room_user_id: _this.anchorId,
      };
      this.$jsonp(this.$apis("flower_anchorFinfo"), data, (res) => {
        if (res.data.ret == 200) {
          _this.type = res.data.data.anchor_flower_type;
          _this.isBind = res.data.data.is_bind_anchor;
          _this.anchorAllSunny = res.data.data.anchor_sunny_amount * 1;
          _this.anchorTotal = _this.anchorAllSunny;
          _this.canUseNum = res.data.data.usable_sunny_amount * 1;
          if (_this.anchorAllSunny * 1 > 999999) {
            _this.anchorTotal = _this.textOverSix(_this.anchorAllSunny * 1);
          }
          _this.meRank = res.data.data.rank_flower;
          _this.meName = res.data.data.me_nickname;
          _this.meAvat = res.data.data.me_avatar;
          _this.meSunCalu = res.data.data.have_been_used_sunny * 1;
          _this.meSunNum = res.data.data.have_been_used_sunny * 1;
          if (_this.meSunNum > 999999) {
            _this.meSunNum = _this.textOverSix(_this.meSunNum);
          }
          _this.rankList = res.data.data.list;

          _this.rankList.forEach((ele) => {
            if (ele.pay_sunny_amount * 1 > 999999) {
              ele.pay_sunny_amount = _this.textOverSix(
                ele.pay_sunny_amount * 1
              );
            }
          });
          if (res.data.data.list.length == 0) {
            _this.showNo = true;
          }
        } else {
          _this.$tool.tipImg(res.data.data, "error");
        }
      });
    },

    // 过万的处理
    textOverSix(value) {
     if (value > 999999 && value <= 9999999) {
        value = (value / 10000).toFixed(2) + "w";
      } else if (value > 9999999 &&  value <= 99999999) {  
        value = (value / 10000000).toFixed(2) + "kw";
      } else if (value > 99999999) {  //过亿的处理   
        value = (value / 100000000).toFixed(2) + "e";
      } 
      return value;
    },

    // 洒阳光请求接口  添加阳光的动画
    saBtnStart() {
      let _this = this;
      let data = {
        room_user_id: _this.$route.query.bindid,
      };
      this.$jsonp(this.$apis("flower_saSunny"), data, (res) => {
        if (res.data.ret == 200) {
          document.querySelector(".sa_ani").classList.add("big_animat");
          _this.anchorAllSunny = _this.anchorAllSunny * 1 + _this.canUseNum * 1;
          _this.anchorTotal = _this.anchorAllSunny;
          if (_this.anchorTotal * 1 > 999999) {
            _this.anchorTotal = _this.textOverSix(_this.anchorTotal * 1);
          }

          // 底部贡献值的计算
          _this.meSunCalu = _this.meSunCalu + _this.canUseNum * 1;
          _this.meSunNum = _this.meSunCalu;
          if (_this.meSunNum * 1 > 999999) {
            _this.meSunNum = _this.textOverSix(_this.meSunNum * 1);
          }

          _this.canUseNum = 0;
          _this.canSaSun = false;
          _this.aniObj1 = lottie.loadAnimation({
            container: document.getElementById("anibg"),
            renderer: "svg", // 渲染方式:svg、canvas
            loop: false, //循环播放，默认：false
            autoplay: true, //自动播放 ，默认true
            path: "/flower/zhubg/data.json",
          });
          _this.aniObj1.addEventListener("complete", () => {
            document.querySelector(".total_box").classList.add("allSunAni");
            if (_this.type == 1) {
              document
                .querySelector(".flwr_mg")
                .classList.add("flower_animate");
            } else {
              document
                .querySelector(".flwr_xr")
                .classList.add("flower_animate2");
            }

            _this.getAnchorFlower();

            setTimeout(() => {
              document
                .querySelector(".total_box")
                .classList.remove("allSunAni");
              if (_this.type == 1) {
                document
                  .querySelector(".flwr_mg")
                  .classList.remove("flower_animate");
              } else {
                document
                  .querySelector(".flwr_xr")
                  .classList.remove("flower_animate2");
              }
            }, 2000);
          });
        } else {
          _this.$tool.tipImg(res.data.data, "error");
        }
      });
    },
  },
};
</script>






<style scoped>
#my_box {
  width: 100%;
  overflow-x: hidden;
  min-height: 100vh;
  background-color: #053a3d;
}
.idx_padd {
  padding-bottom: 55px;
}
.back_box {
  position: fixed;
  top: 8%;
  left: 5%;
  z-index: 19;
}
.back_box img {
  width: 85px;
  height: 32px;
}
.ani_bg {
  position: absolute;
  top: 0;
  left: 0;
}
.flower_one {
  position: absolute;
  top: 0;
  left: 0;
}
.flwr_mg {
  width: 30%;
  top: 32.5%;
  left: 49%;
  transform: translateX(-50%);
}
/* 玫瑰和向日葵的上下抖动 */
.top_con .flower_animate {
  transform-origin: bottom;
  animation: sunDouDong 0.5s linear 2;
}
.top_con .flower_animate2 {
  transform-origin: bottom;
  animation: sunDouDong2 0.5s linear 2;
}

.flwr_xr {
  width: 40%;
  top: 29.5%;
  left: 56%;
  transform: translateX(-50%);
}
/* 我的花卉部分样式 包含收阳光的 */
.me_hua {
  bottom: 23%;
  font-size: 1.3125rem;
  font-weight: bold;
  color: #fff;
}
.total_box {
  bottom: 24%;
  left: 8%;
}
.total_box .sunimg {
  width: 44px;
  height: 44px;
  /* animation: rotateCircle 15s linear infinite; */
}
.allSunAni {
  animation: sunAni 0.3s linear 1;
}
.sun_allcon {
  width: 52px;
  height: 52px;
  border: 4px solid #ffda7b;
  border-radius: 50%;
  background-color: #ba680d;
}
.total_box .sun_num {
  margin-top: -12px;
  font-size: 0.8125rem;
  font-weight: bold;
  color: #fff;
  text-align: center;
  text-shadow: 1px 1px 0 #df5e00, -1px -1px 0 #df5e00, -1px 1px 0 #df5e00,
    1px -1px 0 #df5e00;
  -webkit-text-shadow: 1px 1px 0 #df5e00, -1px -1px 0 #df5e00,
    -1px 1px 0 #df5e00, 1px -1px 0 #df5e00;
}

/* 洒阳光的 */
.sasun_box {
  top: 62.5%;
  right: 5%;
}

.baisun_con .bai_sbg {
  margin: 0 auto;
  width: 78px;
  height: 78px;
}
.bai_sun {
  width: 66px;
  height: 66px;
  top: 8%;
  left: 15%;
  /* animation: rotateCircle 15s linear infinite; */
}
.sa_btns {
  margin-top: -12px;
}
.sa_btns img {
  width: 94px;
  height: 50px;
}
.sasun_box.big_animat {
  animation: bigBtnAni 0.5s linear 1;
}
.can_sun {
  top: 22%;
  right: -6%;
  width: 28px;
  height: 21px;
}
.can_sun img {
  width: 28px;
  height: 21px;
}
.can_sun p {
  top: 11%;
  color: #fff;
  font-size: 11px;
}

/* 榜单部分样式 */
.main_con {
  width: 100%;
  background-color: #053a3d;
  margin-top: -36%;
}
.btn_top {
  z-index: 2;
  font-size: 16px;
  font-weight: bold;
  color: #ffecc8;
}
.bgimg_btn {
  width: 175px;
  height: 51px;
  margin: 0 auto;
}
.mar_top {
  margin-top: -31px;
}
.sp_p {
  width: 100%;
  padding-top: 20px;
  text-align: center;
  font-size: 11px;
  color: #096b55;
}

/* 自己的样式 */
.me_fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 3;
}
.me_main {
  width: 100%;
}
.me_pai .mepai_img {
  width: 26px;
  height: 18px;
}
.me_box {
  top: 16%;
  left: 5%;
  align-items: center;
}
.me_avat {
  width: 2.875rem;
  height: 2.875rem;
  border: 2px solid #ffe5d4;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 12px;
}
.me_avat img {
  width: 2.875rem;
  height: 2.875rem;
}
.wei_pai {
  font-size: 0.75rem;
  font-weight: bold;
  color: #fff6e4;
}
.me_info p:nth-child(1) {
  width: 90%;
  font-size: 0.9375rem;
  color: #fff6e4;
  font-weight: bold;
}
.me_info p:nth-child(2) {
  font-size: 0.75rem;
  color: #bf9f85;
  font-weight: bold;
}
</style>